import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySimulation } from "../../entity/EntitySimulation";

export class DtoSimulationsGetReq extends EntitySimulation {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_claim_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
